import { useSyncExternalStore } from 'react';

/**
 * Whether this browser has opened Ads yet, for the sidebar "New" tag (same as Stories' lib/seen.ts).
 * localStorage can be blocked; on failure the tag keeps showing.
 */
export const ADS_SEEN_KEY = 'og-ads-seen';
const EVENT = 'og-ads-seen';

function read(): boolean {
  try {
    return window.localStorage.getItem(ADS_SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

export function markAdsSeen(): void {
  try {
    if (window.localStorage.getItem(ADS_SEEN_KEY) === '1') return;
    window.localStorage.setItem(ADS_SEEN_KEY, '1');
  } catch {
    return;
  }
  window.dispatchEvent(new Event(EVENT));
}

function subscribe(onChange: () => void): () => void {
  const onStorage = (e: StorageEvent) => {
    if (e.key === ADS_SEEN_KEY) onChange();
  };
  window.addEventListener(EVENT, onChange);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(EVENT, onChange);
    window.removeEventListener('storage', onStorage);
  };
}

export function useAdsSeen(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}
